<template>
    <div class="container mt-3">
        <div class="new-create">
            <div class="row">
                <div class="col-md-12 new-background mb-5">

                    <h1 class="mb-4 mt-4 new-heading" v-if="!news">Update News</h1>
                    <h1 class="mb-4 mt-4 new-heading" v-if="news">Add News</h1>

                    <form>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>News Title</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter Title"
                                           v-model="newsAdd.news_title" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                            <div class="form-group">
                            <label><b>News Subtitle</b></label>
                            <input type="text"
                            class="form-control"
                            placeholder="Enter Subtitle"
                                   v-model="newsAdd.news_subtitle" required>
                            </div>
                            </div>
                        </div>
                        <!--<div class="row">-->
                            <!--<div class="col-md-6">-->
                                <!--<div class="form-group">-->
                                    <!--<label><b>News Url</b></label>-->
                                    <!--<input type="text"-->
                                           <!--class="form-control"-->
                                           <!--placeholder="Enter Title"-->
                                           <!--v-model="newsAdd.news_url" required>-->
                                <!--</div>-->
                            <!--</div>-->
                            <!--<div class="col-md-6"></div>-->
                        <!--</div>-->
                        <div class="form-group mb-3">
                            <label><b>News Description</b></label>
                            <editor v-model="newsAdd.news_short_description" v-validate="'required|min:16'"
                                    name="news_description"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="news description"></editor>
                            <small v-if="errors.has('event_description')" class="text-danger">
                                {{ errors.first('news_description') }}
                            </small>
                        </div>

                        <div class="form-group mb-3">
                            <label><b>News Content</b></label>
                            <editor v-model="newsAdd.news_content" v-validate="'required|min:16'"
                                    name="event_description"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="news content"></editor>
                            <small v-if="errors.has('news_content')" class="text-danger">
                                {{ errors.first('event_works') }}
                            </small>
                        </div>

                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!news"
                                    @click="update_News()">UPDATE NEWS
                            </button>
                            <button type="button" class="btn btn-primary" v-if="news" @click="add_News()">ADD NEWS
                            </button>
                            <router-link :to="{name: 'website-news'}" class="btn my-4 btn-seondary">
                                Back
                            </router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from "lodash";
import router from "../router";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";

export default {
  name: "CreateNews",
  components: { Editor },
  data() {
    return {
      newsAdd: {},
      news: true
    };
  },
  methods: {
    add_News: function() {
      this.newsAdd.access_token = localStorage.getItem("access_token");
      console.log(this.newsAdd);
      axios({
        method: "POST",
        url: "admin/news/new",
        data: this.newsAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("News Added Successfully", "", "success");
            router.push("website-news");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          error;
        }
      );
    },
    getSingle_News() {
      axios({
        url:
          "/admin/news/" +
          this.$route.params.news_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.newsAdd = result.data.news;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_News: function() {
      this.newsAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url: "/admin/news/update/" + this.$route.params.news_id,
        data: this.newsAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("News Updated Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          let errors = error.response.data.error;
          for (let error in errors) {
            this.$noty.error("Error: " + _.startCase(errors[error][0]));
          }
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.news_id > 0) {
      this.news = false;
      this.getSingle_News();
    } else {
      this.newsAdd = {};
      this.news = true;
    }
  }
};
</script>

<style lang="scss">
.new-create {
  padding-right: 20px;
  padding-left: 20px;
  .new-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .new-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
